import { IconPropsType } from '..';

export const ErrorInfoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="kb-core-icon">
      <g
        id="Frame"
        clipPath="url(#clip0_7276_236756)"
      >
        <g
          id="Frame_2"
          clipPath="url(#clip1_7276_236756)"
        >
          <path
            id="Vector"
            d="M9.32148 1.39999H4.67857L1.40002 4.67854V9.32145L4.67857 12.6H9.32148L12.6 9.32145V4.67854L9.32148 1.39999ZM11.4698 8.85309L8.85312 11.4698H5.14693L2.53021 8.85309V5.1469L5.14693 2.53018H8.85312L11.4698 5.1469V8.85309ZM6.30003 9.1L7.70002 9.09999V10.5L6.30002 10.5L6.30003 9.1ZM6.30003 3.49999L7.70002 3.49999L7.70003 8.39999L6.30003 8.39999V3.49999Z"
            fill="#EA6161"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7276_236756">
        <rect
          width="11.2"
          height="11.2"
          fill="white"
          transform="translate(1.40002 1.39999)"
        />
      </clipPath>
      <clipPath id="clip1_7276_236756">
        <rect
          width="11.2"
          height="11.2"
          fill="white"
          transform="translate(1.40002 1.39999)"
        />
      </clipPath>
    </defs>
  </svg>
);
